export function proximoVencimento(parcelas) {
  const comData = parcelas.filter(parcela => parcela.dataVencimento);
  const emAberto = comData.filter(parcela => parcela.status !== "Pago");
  const candidatas = emAberto.length > 0 ? emAberto : comData;
  if (candidatas.length === 0) {
    return "";
  }

  const ordenadas = [...candidatas].sort((a, b) => new Date(a.dataVencimento) - new Date(b.dataVencimento));
  const escolhida = emAberto.length > 0 ? ordenadas[0] : ordenadas[ordenadas.length - 1];

  return escolhida.dataVencimento;
}
